import React, { useState, useEffect } from "react";
import cssClasses from "./ViewDocumentsModal.module.css";
import { Box, IconButton, Modal, Tab } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../../Subcomponents/Button";
import {
  getFarvisionStatusForPNRD,
  sendWelcomePdf,
} from "../../../../Services/AllAllotments";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import useAlertModal from "../../../../Subcomponents/useAlertModal";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import DynamicAllotmentLetter from "../../../AllotmentLetter/DynamicAllotmentLetter";
import { getTemplateForAllotment } from "../../../../Services/AllotmentLetterTemplate";

function ViewDocumentsModal({
  open,
  handleClose,
  selectedAllotmentObject,
  sendMailToLead,
  isTableView = false,
  allotmentTableData = [],
  isCompleteTab = false,
  viewCostSheet = false,
}) {
  const [pdfBase64CostSheetA, setPdfBase64CostSheetA] = useState("");
  const { showError, AlertModal } = useAlertModal();
  const [viewCount, setViewCount] = useState(0);
  const [tabLabel, setTabLabel] = React.useState("dynamic");
  const [pdfFile, setPdfFile] = useState([]);
  const [allotmentLetterBase64, setAllotmentLetterBase64] = useState("");
  const [farvisonStatus, setFarvisonStatus] = useState("");
  const [letterTemplate, setLetterTemplate] = useState(null);

  const handleChange = (event, newValue) => {
    setTabLabel(newValue);
  };

  // function submitHandler() {
  //   sendMailToLead();
  // }
  // function submitHandler() {
  //   if (
  //     selectedAllotmentObject.project_id ===
  //     "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077"
  //   ) {
  //     if (!pnrdAllotmentLetterBase64) {
  //       errorTost("Allotment Letter is still generating. Please wait.");
  //       return;
  //     }

  //     console.log(
  //       "📤 Sending Allotment Letter Base64 size:",
  //       pnrdAllotmentLetterBase64.length,
  //     );

  //     sendMailToLead(pnrdAllotmentLetterBase64);
  //   } else if (
  //     selectedAllotmentObject.project_id ===
  //     "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09"
  //   ) {
  //     // 🔹 New project condition
  //     if (!PPSBRAllotmentLetterBase64) {
  //       // 👈 replace with your actual variable
  //       errorTost("Allotment Letter is still generating. Please wait.");
  //       return;
  //     }

  //     console.log(
  //       "📤 Sending New PPSBR Project Letter Base64 size:",
  //       PPSBRAllotmentLetterBase64,
  //     );

  //     sendMailToLead(PPSBRAllotmentLetterBase64);
  //   } else {
  //     sendMailToLead();
  //   }
  // }

  //   function submitHandler() {
  //   const projectId = selectedAllotmentObject?.project_id;

  //   const PNRD_ID = "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077";
  //   const PPSBR_ID = "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09";

  //   if (projectId === PNRD_ID) {
  //     if (!pnrdAllotmentLetterBase64) {
  //       errorTost("PNRD Allotment Letter is not ready");
  //       return;
  //     }

  //     sendMailToLead(pnrdAllotmentLetterBase64, null);
  //   }

  //   else if (projectId === PPSBR_ID) {
  //     if (!PPSBRAllotmentLetterBase64) {
  //       errorTost("PPSBR Allotment Letter is not ready");
  //       return;
  //     }

  //     sendMailToLead(null, PPSBRAllotmentLetterBase64);
  //   }

  //   else {
  //     // errorTost("Unsupported project");
  //     sendMailToLead();
  //   }
  // }

  function submitHandler() {
    // Only this project/wing's own Allotment Letter Template makes the letter mandatory here —
    // the backend already treats it as optional (see sendMailWithWelcomePdfAndCrmProfilePdf),
    // so a project with no template configured should never be blocked waiting for it.
    if (shouldShowAllotmentLetterTab() && !allotmentLetterBase64) {
      showError("Allotment Letter is still generating. Please wait.");
      return;
    }
    sendMailToLead(allotmentLetterBase64);
  }

  useEffect(() => {
    const fetchFarvisionStatus = async () => {
      try {
        console.log(
          "allotment===============",
          selectedAllotmentObject?.unit_id,
        );
        if (selectedAllotmentObject?.unit_id) {
          const data = await getFarvisionStatusForPNRD(
            selectedAllotmentObject?.unit_id,
          );
          setFarvisonStatus(data[0]?.farvisionStatus); // now data is already flat
          console.log("farvisionnStatus:", data[0]?.farvisionStatus);
        }
      } catch (err) {
        console.error("Error fetching allotment parking data", err);
      }
    };
    if (selectedAllotmentObject?.unit_id) {
      fetchFarvisionStatus();
    }
  }, [selectedAllotmentObject]);

  useEffect(() => {
    const projectId = selectedAllotmentObject?.project_id;
    const wingId = selectedAllotmentObject?.wing_id ?? null;
    if (projectId) {
      setLetterTemplate(null);
      getTemplateForAllotment(projectId, wingId).then(setLetterTemplate);
    }
  }, [selectedAllotmentObject]);

  function shouldShowAllotmentLetterTab() {
    if (!letterTemplate) return false;
    const cond = letterTemplate.show_condition || "always";
    if (cond === "always") return true;
    if (cond.startsWith("status:")) return farvisonStatus === cond.slice(7);
    if (cond.startsWith("not:")) return farvisonStatus !== cond.slice(4);
    return true;
  }

  console.log("selectedAllotmentObject============", selectedAllotmentObject);
  async function getWelcomePdfFromServer() {
    try {
      presentLoader();
      const getWelcomePdfResponse = await sendWelcomePdf(
        isTableView
          ? allotmentTableData[viewCount]?.id
          : selectedAllotmentObject.id,
        null,
        true,
      );

      console.log("getWelcomePdfResponse============", getWelcomePdfResponse);

      if (getWelcomePdfResponse.data?.success) {
        setPdfFile(getWelcomePdfResponse.data?.files);
        // FIXED (Cost Sheet Format Redesign): a large PDF embedded directly as a base64 data: URI
        // silently fails to render in the iframe (Chrome has an undocumented size ceiling for
        // data: URIs used as a navigation target). Building a Blob object URL instead has no such
        // limit and is the standard way to preview large files in an iframe.
        const base64 = getWelcomePdfResponse.data?.pdfData?.pdfBase64CostSheetA;
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: "application/pdf" });
        setPdfBase64CostSheetA(URL.createObjectURL(blob));
      } else {
        showError(getWelcomePdfResponse.data?.error?.message || "Something went wrong! Try again");
      }
      dismissLoader();
    } catch (error) {
      const msg = error?.error?.message || error?.message || String(error);
      showError(msg);
      dismissLoader();
    }
  }

  useEffect(() => {
    if (selectedAllotmentObject && selectedAllotmentObject?.id) {
      getWelcomePdfFromServer();
    }
  }, [selectedAllotmentObject]);

  useEffect(() => {
    if (allotmentTableData?.length > 0) {
      getWelcomePdfFromServer();
    }
  }, [viewCount]);

  useEffect(() => {
    if (allotmentTableData?.length > 0) {
      setViewCount(0);
    }
  }, [allotmentTableData]);

  return (
    <React.Fragment>
    <Modal
      open={open}
      onClose={() => handleClose({ flag: false })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>View Documents</h1>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
          <IconButton
            className={cssClasses.crossButton}
            onClick={() => handleClose({ flag: false })}
          >
            {" "}
            <CloseIcon />{" "}
          </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          <div className={cssClasses.documentWrapper}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabLabel}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList onChange={handleChange}>
                    <Tab
                      label="Cost sheet"
                      value="dynamic"
                      sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                    />
                    <Tab
                      label="CRM Profile"
                      value="static"
                      sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                    />
                    {/* {(selectedAllotmentObject.project_id ===
                      "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" || selectedAllotmentObject.project_id ===
                      "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09" ) &&
                      farvisonStatus === "Available" && (
                        <Tab
                          label="Allotment Letter"
                          value="allotmentLetter"
                          sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                        />
                      )} */}
                    {/* {((selectedAllotmentObject.project_id ===
                      "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" &&
                      farvisonStatus === "Available") ||
                      (selectedAllotmentObject.project_id ===
                        "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09" &&
                        farvisonStatus !== "HOLD")) && (
                      <Tab
                        label="Allotment Letter"
                        value="allotmentLetter"
                        sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                      />
                    )} */}
                    {shouldShowAllotmentLetterTab() && (
                      <Tab
                        label="Allotment Letter"
                        value="allotmentLetter"
                        sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                      />
                    )}
                  </TabList>
                </Box>
                <TabPanel value="dynamic">
                  {" "}
                  {isTableView && (
                    <div
                      style={{
                        display: "flex",
                        fontSize: "1.5rem",
                        gap: "20px",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px" }}>
                        <p style={{ fontWeight: 700 }}>Lead Details: </p>

                        {isCompleteTab && (
                          <p style={{ whiteSpace: "break-spaces" }}>
                            {allotmentTableData[viewCount]?.lead_name}
                          </p>
                        )}
                      </div>
                      <div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <p style={{ fontWeight: 700 }}>Unit Details :</p>
                          {isCompleteTab && (
                            <div>
                              {!allotmentTableData[viewCount]
                                .inventory_merge_id && (
                                <span>
                                  {" "}
                                  {allotmentTableData[viewCount].displaywingname
                                    ? allotmentTableData[viewCount]
                                        .displaywingname
                                    : allotmentTableData[viewCount]
                                        .wing_name}{" "}
                                  - {allotmentTableData[viewCount].unit_no}{" "}
                                </span>
                              )}
                              {allotmentTableData[viewCount]
                                .inventory_merge_id && (
                                <span>
                                  {allotmentTableData[viewCount]
                                    .mergeddisplaywingname
                                    ? allotmentTableData[viewCount]
                                        .mergeddisplaywingname
                                    : allotmentTableData[viewCount]
                                        .merged_wing_name}{" "}
                                  -{" "}
                                  {
                                    allotmentTableData[viewCount]
                                      .merged_unit_no_one
                                  }{" "}
                                  {"-"}{" "}
                                  {
                                    allotmentTableData[viewCount]
                                      .merged_unit_no_two
                                  }{" "}
                                </span>
                              )}
                            </div>
                          )}
                          {isCompleteTab && (
                            <div>
                              {!allotmentTableData[viewCount]
                                .inventory_merge_id && (
                                <span>
                                  {allotmentTableData[viewCount].project_name}
                                </span>
                              )}
                              {allotmentTableData[viewCount]
                                .inventory_merge_id && (
                                <span>
                                  {
                                    allotmentTableData[viewCount]
                                      .merged_project_name
                                  }
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {pdfBase64CostSheetA && (
                    <div className={cssClasses.documentContainer}>
                      <iframe
                        src={pdfBase64CostSheetA + "#zoom=100&page=1"}
                        frameBorder="0"
                        title={`costing_document_A`}
                      ></iframe>
                    </div>
                  )}
                </TabPanel>
                <TabPanel value="static">
                  {isTableView && (
                    <div
                      style={{
                        display: "flex",
                        fontSize: "1.5rem",
                        gap: "20px",
                      }}
                    >
                      <p style={{ fontWeight: 700 }}>CRM Name :</p>
                      <p>
                        {isCompleteTab
                          ? allotmentTableData[viewCount]?.crm_user_name
                          : allotmentTableData[viewCount]?.crmUserId?.name}
                      </p>
                    </div>
                  )}
                  {!isTableView &&
                    selectedAllotmentObject?.crm_user_doc_url &&
                    selectedAllotmentObject?.crm_user_doc_url?.map(
                      (docItem, docIndex) => (
                        <div
                          key={`document_${docIndex}`}
                          className={cssClasses.documentContainer}
                        >
                          <iframe
                            src={docItem}
                            frameBorder="0"
                            title={`document_${docIndex}`}
                          ></iframe>
                        </div>
                      ),
                    )}
                  {isTableView &&
                    allotmentTableData[viewCount]?.crm_user_doc_url &&
                    allotmentTableData[viewCount]?.crm_user_doc_url?.map(
                      (docItem, docIndex) => (
                        <div
                          key={`document_${docIndex}`}
                          className={cssClasses.documentContainer}
                        >
                          <iframe
                            src={docItem}
                            frameBorder="0"
                            title={`document_${docIndex}`}
                          ></iframe>
                        </div>
                      ),
                    )}
                  {pdfFile &&
                    pdfFile.map((docItem, docIndex) => (
                      <div
                        key={`document_${docIndex}`}
                        className={cssClasses.documentContainer}
                      >
                        <iframe
                          src={docItem}
                          frameBorder="0"
                          title={`document_${docIndex}`}
                        ></iframe>
                      </div>
                    ))}
                </TabPanel>

                {/* {// Old project condition
                ((selectedAllotmentObject?.project_id ===
                  "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" &&
                  farvisonStatus === "Available") ||
                  // New project condition (River Front)
                  (selectedAllotmentObject?.project_id ===
                    "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09" &&
                    farvisonStatus !== "HOLD")) && (
                  <TabPanel value="allotmentLetter">
                    {selectedAllotmentObject?.project_id ===
                    "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" ? (
                      // 🔹 Existing Project Logic
                      selectedAllotmentObject?.wing_id ===
                      "f61a1b3a-fc89-43e9-86e2-bee61dc884dd" ? (
                        <PNRDAllotmentLetterWingD
                          allotment={
                            isTableView
                              ? allotmentTableData[viewCount]
                              : selectedAllotmentObject
                          }
                          onPdfGenerated={setPnrdAllotmentLetterBase64}
                        />
                      ) : (
                        <PNRDAllotmentLetter
                          allotment={
                            isTableView
                              ? allotmentTableData[viewCount]
                              : selectedAllotmentObject
                          }
                          onPdfGenerated={setPnrdAllotmentLetterBase64}
                        />
                      )
                    ) : selectedAllotmentObject?.project_id ===
                      "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09" ? (
                      // 🔹 NEW PROJECT LOGIC
                      <PPSBRAllotmentLetterT4T5
                        allotment={
                          isTableView
                            ? allotmentTableData[viewCount]
                            : selectedAllotmentObject
                        }
                        onPdfGenerated={setPPSBRAllotmentLetterBase64}
                      />
                    ) : null}
                  </TabPanel>
                )} */}

                {shouldShowAllotmentLetterTab() && (
                  <TabPanel value="allotmentLetter">
                    <DynamicAllotmentLetter
                      allotment={
                        isTableView
                          ? allotmentTableData[viewCount]
                          : selectedAllotmentObject
                      }
                      onPdfGenerated={setAllotmentLetterBase64}
                    />
                  </TabPanel>
                )}
              </TabContext>
            </Box>
          </div>
        </div>

        {isTableView && viewCount < allotmentTableData?.length - 1 && (
          <div className={cssClasses.footer}>
            <div>
              <Button
                style={{ color: "#344054", backgroundColor: "#ffffff" }}
                btnName={"Previous"}
                clicked={() => {
                  if (viewCount > 0) {
                    setViewCount((prev) => prev - 1);
                  }
                }}
                disable={viewCount === 0}
              />
            </div>
            <div>
              <Button
                style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
                btnName={"Next"}
                disable={viewCount >= allotmentTableData?.length - 1}
                clicked={() => {
                  setViewCount((prev) => prev + 1);
                }}
              />
            </div>
          </div>
        )}
        {(!isTableView || viewCount === allotmentTableData?.length - 1) && (
          <div className={cssClasses.footer}>
            {isTableView && allotmentTableData?.length > 1 && (
              <div>
                <Button
                  style={{ color: "#344054", backgroundColor: "#ffffff" }}
                  btnName={"Previous"}
                  clicked={() => {
                    if (viewCount > 0) {
                      setViewCount((prev) => prev - 1);
                    }
                  }}
                  disable={viewCount === 0}
                />
              </div>
            )}
            <div>
              <Button
                style={{ color: "#344054", backgroundColor: "#ffffff" }}
                btnName={"Cancel"}
                clicked={() => handleClose({ flag: false })}
              />
            </div>
            {!viewCostSheet && (
              <div>
                <Button
                  style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
                  btnName={"Send Mail To Customer"}
                  // disable={!Boolean(pdfBase64CostSheetA)} //&& pdfBase64CostSheetB
                  // disable={
                  //   selectedAllotmentObject.project_id ===
                  //   "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077"
                  //     ? !Boolean(pnrdAllotmentLetterBase64)
                  //     : !Boolean(pdfBase64CostSheetA)

                  //   // !Boolean(pnrdAllotmentLetterBase64) ||
                  //   // !Boolean(pdfBase64CostSheetA)
                  // }

                  // disable={
                  //   selectedAllotmentObject.project_id ===
                  //   "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077"
                  //     ? !Boolean(pnrdAllotmentLetterBase64)
                  //     : selectedAllotmentObject.project_id ===
                  //         "f6c02aa9-dc6f-49dc-9ae6-c3377fe60c09"
                  //       ? !Boolean(PPSBRAllotmentLetterBase64) // 👈 your new variable
                  //       : !Boolean(pdfBase64CostSheetA)
                  // }
                  clicked={() => {
                    submitHandler();
                  }}
                />
              </div>
            )}
          </div>
        )}
      </Box>
    </Modal>
    {AlertModal}
    </React.Fragment>
  );
}

export default ViewDocumentsModal;
const labelStyle = {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#344054",
  marginBottom: "0.8rem",
};
function isEmailValid(inputText) {
  let flag = true;
  let helperText = "";
  // eslint-disable-next-line
  var mailFormat =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if (!inputText || inputText === "") {
    flag = false;
    helperText = "Please Enter email address.";
  } else if (!String(inputText).toLowerCase().match(mailFormat)) {
    flag = false;
    helperText = "Please Enter Valid Email Address.";
  }
  return { flag, helperText };
}
